const ProductSalesMode = Object.freeze({
  Normal: 0,
  Weekend: 1,
  Cert: 2,
  Delivery: 3,
  AlcoholDelivery: 4,
  Movie: 5,
  Camping: 6
})

const ProductTimeMode = Object.freeze({
  Days7: 0,
  Days30: 1,
  Days180: 2,
  Days60: 3,
  Days90: 4,
  Days365: 5
})

const ProductCancelType = Object.freeze({
  FunNow: 0,
  Ezbook: 1,
  Custom: 2
})

const ProductFBCancelType = Object.freeze({
  SameAsFunNow: 0,
  Custom: 1
})

const ProductShowOn = Object.freeze({
  FunNowGroup: 0,
  FunBook: 1,
  FunNowGroupAndFunbook: 2
})

const ProductTagType = Object.freeze({
  Facility: 0,
  Category: 1,
  Normal: 2,
  Event: 3,
  FlashSale: 4,
  Uniq: 5,
  Review: 6,
  UserRights: 7,
  RegionLabel: 8,
  Cuisine: 9, // deprecated: Cuisine tag is merged into Normal tag
  ServiceLanguage: 10,
  PaymentMethod: 11,
  Atmosphere: 12,
  SpecialDiet: 13,
  CardVerification: 14,
  NLPData: 29,
  Chatbot: 66
})

const ProductListType = Object.freeze({
  Main: 0,
  Addon: 1,
  All: 2
})

const ProductAddType = Object.freeze({
  NotAdd: 0,
  All: 1,
  Custom: 2
})

const ProductHexaSyncType = Object.freeze({
  Overnight: 0,
  Rest: 1
})

const ProductHexaSyncSetType = Object.freeze({
  Default: 0,
  Range: 1
})

const ProductHexaSyncResourceType = Object.freeze({
  Disabled: 0,
  Enabled: 1
})

const ProductHexaSyncPriceType = Object.freeze({
  Disabled: 0,
  Enabled: 1
})

const ProductCoolingOff = Object.freeze({
  Disabled: 0,
  Enabled: 1
})

const ProductBookingMode = Object.freeze({
  Normal: 0,
  SeatOnly: 1
})

const ProductPaymentMode = Object.freeze({
  Online: 0,
  Onsite: 1
})

const ProductNoShowPenalty = Object.freeze({
  Disabled: 0,
  Enabled: 1
})

const ProductFunCoinType = Object.freeze({
  Disabled: 0,
  Enabled: 1
})

const CancelRuleMode = Object.freeze({
  Day: 0,
  Date: 1,
  Hour: 2,
  BookingTime: 3
})

export {
  ProductSalesMode,
  ProductTimeMode,
  ProductCancelType,
  ProductFBCancelType,
  ProductShowOn,
  ProductTagType,
  ProductListType,
  ProductAddType,
  ProductHexaSyncType,
  ProductHexaSyncSetType,
  ProductHexaSyncResourceType,
  ProductHexaSyncPriceType,
  ProductCoolingOff,
  ProductBookingMode,
  ProductPaymentMode,
  ProductNoShowPenalty,
  ProductFunCoinType,
  CancelRuleMode
}
